export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_05.40a8bdc1.png";